import { render, staticRenderFns } from "./asset-types.vue?vue&type=template&id=04e41948&scoped=true&"
import script from "./asset-types.vue?vue&type=script&lang=js&"
export * from "./asset-types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e41948",
  null
  
)

export default component.exports